import { render, staticRenderFns } from "./ExpiredDialog.vue?vue&type=template&id=9cefead2"
import script from "./ExpiredDialog.vue?vue&type=script&lang=js"
export * from "./ExpiredDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports